import BlogPagination from './blogPagination'

export default BlogPagination